module.exports = __webpack_public_path__ + "media/images/sort_asc-14009a6d4d501c0fdeb7e954202ee846.png";